import { Fragment } from 'react';

import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';

// Types
import type { SideBarProps } from '@/components/layouts/LayoutPlatform/components/Menu/MenuMobile/Sidebar';

type WrapperProps = SideBarProps & {
    children: React.ReactNode;
};

export function Wrapper({ isMenuOpen, toggleMenu, children }: WrapperProps) {
    return (
        <Transition show={isMenuOpen} as={Fragment}>
            <Dialog
                as="div"
                static
                className="fixed inset-0 z-50 overflow-hidden"
                open={isMenuOpen}
                onClose={toggleMenu}>
                <div className="absolute inset-0 overflow-hidden">
                    <div className="fixed inset-y-0 left-0 flex max-w-full">
                        <TransitionChild
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0">
                            <div className="fixed inset-0 bg-icoBlack/30 dark:bg-icoDarkMode-anthracite/30" />
                        </TransitionChild>
                        <TransitionChild
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="-translate-x-full backdrop-blur-sm"
                            enterTo="translate-x-0 backdrop-blur-sm"
                            leave="backdrop-blur-sm transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full">
                            <DialogPanel className="z-1 w-60">
                                <div className="flex h-full flex-col border border-white bg-white px-1 pb-1 pt-12.5 dark:bg-icoDarkMode-deepBlack">
                                    {children}
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
